import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({});
};



// WEBPACK FOOTER //
// ./src/services/whiteLabelSettings.js